// eslint-disable-next-line import/prefer-default-export
export const isEmailGlobalDomain = (email: string) =>
  email.trim().endsWith('@global.com');
